import popOutExportBookingTemplate from './popout_export_booking.html';
import popoverLayoutTemplate from './popover_layout.html';

// Styles for horizontal layout.
import './popover_layout.scss';

function bookingExportDirective(GeneralOptions) {
    'ngInject';

    return {
        restrict: 'AE',
        scope: {
            booking: '=bbBookingExport'
        },
        templateUrl: popOutExportBookingTemplate.id,
        controller($scope) {
            $scope.layoutUrl = popoverLayoutTemplate.id;

            if (['row', 'column'].includes(GeneralOptions.bookingExport.layout)) {
                $scope.layout = GeneralOptions.bookingExport.layout;
            } else {
                // Fallback option.
                $scope.layout = 'column';
            }

            // FIXME: It's here only because right now images cannot be used inside templates (webpack fix needed).
            $scope.images = {
                outlook: require('core/_images/outlook.png'),
                google: require('core/_images/google.png'),
                ical: require('core/_images/ical.png')
            };
        }
    };
}

angular
    .module('BB')
    .directive('bbBookingExport', bookingExportDirective);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/booking-export/bb_booking_export.directive.js